define('app/sdc/wizard/submit/sdc-wizard-submit',[], function () {
	return {
		restrict: "A",
		template: null,
		scope: false,
		controller: {
			bind: {
				"submit": "&sdcWizardSubmit"
			}
		}
	};
});
